import React, { useRef } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import { Container, InputGroup, Form } from 'react-bootstrap';
import Testimonials from './Testimonials';
import { useState } from 'react';
import Alert from './Alert';

// Renamed component to match the filename. 
// Destructure the onStepComplete prop directly:
const RegisterProfile = ({ complete, forced }) => {
  const emailRef = useRef();
  const nameRef = useRef();
  const passwordRef = useRef();
  const usernameRef = useRef();
  
  // This function is called when the form is submitted
  const handleButtonClick = (e) => {
    e.preventDefault();
    if (!forced) {
      window.location.href = '/dashboard';
    } else {
      complete();
    }
  };

  const [platform, setPlatform] = useState('instagram');
  const [username, setUsername] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [adding, setAdding] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");

  const searchAccount = async (username) => {
    try {
		setSearching(true);
      const response = await axios.post('https://api.viralgpt.com/auth/search', {
        platform,
        username
      });
      setSearchResults(response.data.data);
    } catch (err) {
      setFunctionError(err.response?.data?.message || 'Failed to search for account.');
    } finally {
      setSearching(false);
    }
  };


  const addAccount = async (username) => {
    try {
		setAdding(true);
      const response = await axios.post('https://api.viralgpt.com/auth/link', 
        {
          platform,
          username
        },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      );
      setAccounts([...accounts, { platform, username, photo: response.data.photo, profileid: response.data.profileid }]);
      setPlatform('instagram');
      setUsername('');
	    setAdding(false);
      setFunctionSuccess(`Successfully linked ${username} ${platform} account.`);
      // Select the newly added profile
      await axios.post("https://api.viralgpt.com/auth/select", {
        profileid: response.data.profileid
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      });

    } catch (err) {
      setFunctionError(err.response?.data?.error || err.response?.data?.message || 'Profile not found. Please check your username and try again.');
	    setAdding(false);
    }
  };

  const removeAccount = async (index) => {
    setAccounts(accounts.filter((_, i) => i !== index));
	const response = await axios.post('https://api.viralgpt.com/auth/unlink', 
	  {
		profileid: accounts[index].profileid
      },
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
      }
    );


  };



  return (
    <div>
      <Container className="bg-white shadow-lg rounded p-4 my-12 justify-content-center text-center max-w-lg" fluid>
       
	
        <Form onSubmit={handleButtonClick}>
          <h1 className="font-bold mb-1 text-instagram">Link your profiles</h1>
          <small className="text-muted mb-3 d-block">
            Link your social media accounts to access the dashboard. You can add multiple accounts.
          </small>

          <Alert 
            variant="danger" 
            message={functionError} 
            show={!!functionError} 
            onClose={() => setFunctionError("")} 
          />

          <Alert 
            variant="success" 
            message={functionSuccess} 
            show={!!functionSuccess} 
            onClose={() => setFunctionSuccess("")} 
          />

          {/* List of added accounts */}
          <div className="mb-4">
            {accounts.map((account, index) => (
              <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded mb-2">
                <div className="flex items-center">
					{account.photo && (
						<img 
							src={account.platform === 'youtube' ? 'https://rizzup.net/proxy/' + encodeURIComponent(account.photo) : account.photo} 
							className="w-10 h-10 rounded-full me-2" 
						/>
					)}
                  <i className={`fab fa-${account.platform} me-2 ${
                    account.platform === 'instagram' ? 'text-pink-600' : 
                    account.platform === 'youtube' ? 'text-red-600' :
                    'text-black'
                  }`}></i>
                  <span>{account.username}</span>
                </div>
                <button 
                  onClick={() => removeAccount(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
          </div>

          {/* Add new account form */}
          <div className="grid grid-cols-2 gap-3 bg-gray-50 rounded-xl p-2 mb-6 w-full">
            <button
              type="button"
              onClick={() => setPlatform('instagram')}
              className={`px-4 py-3 rounded-lg flex items-center justify-center transition-all duration-200 ${
                platform === "instagram" ? "bg-instagram shadow-md rounded text-white font-medium" : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <i className="fab fa-instagram text-xl me-2"></i>
              Instagram
            </button>
            <button 
              type="button"
              onClick={() => setPlatform('tiktok')}
              className={`px-4 py-3 rounded-lg flex items-center justify-center transition-all duration-200 ${
                platform === "tiktok" ? "bg-black shadow-md text-white font-medium" : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <i className="fab fa-tiktok text-xl me-2"></i>
              TikTok
            </button>
            <button
              type="button" 
              onClick={() => setPlatform('youtube')}
              className={`px-4 py-3 rounded-lg flex items-center justify-center transition-all duration-200 ${
                platform === "youtube" ? "text-white shadow-md bg-red-600 font-medium" : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <i className="fab fa-youtube text-xl me-2"></i>
              YouTube
            </button>
            <button
              type="button" 
              onClick={() => setPlatform('x')}
              className={`px-4 py-3 rounded-lg flex items-center justify-center transition-all duration-200 ${
                platform === "x" ? "bg-black shadow-md text-white font-medium" : "text-gray-600 hover:bg-gray-100"
              }`}
            >
			  <span className={`${platform === 'x' ? 'bg-black' : 'bg-gray-500'} px-1 rounded-md text-white text-sm me-2`}>𝕏</span>
              Twitter
            </button>
          </div>

          <div className="flex gap-2 mb-4">
            <InputGroup size="md">
              <InputGroup.Text id="username-addon" className="py-3">
                <i className="fa-solid fa-at" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Enter username" 
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                aria-label="Username"
                aria-describedby="username-addon"
              />
            </InputGroup>
            <Button 
              variant="primary"
              onClick={platform === 'youtube' ? () => searchAccount(username) : () => addAccount(username)}
              disabled={adding || searching}
              className="px-4"
              type="button"
            >
              {adding || searching ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                </>
              ) : platform === 'youtube' ? 'Search' : 'Add'}
            </Button>
          </div>
          {platform === 'youtube' && (
            <div className="mb-4">
              {searchResults?.map((result, index) => (
                <div key={index} className="bg-gray-50 p-2 rounded mb-2 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <img src={"https://rizzup.net/proxy/" + encodeURIComponent(result.thumbnail[0].url.startsWith('//') ? 'https:' + result.thumbnail[0].url : result.thumbnail[0].url)} className="me-2" />
                    <span>{result.channelTitle}</span>
                  </div>
                  <Button
                    variant="outline-primary"
                    onClick={() => {
                      addAccount(result.channelId);
                    }}
                    className="rounded-circle"
                    size="sm"
                  >
                    <i className="fas fa-plus"></i>
                  </Button>
                </div>
              ))}
            </div>
          )}

          <Button 
            variant="primary" 
            type="submit" 
            className="w-full bg-instagram"
            disabled={accounts.length === 0}
          >
				<strong>Continue</strong> <i className="fas fa-arrow-right ms-2"></i>
          </Button>
        </Form>
		{!forced && (
        <small className="d-block text-muted mt-6">
          Want to skip this step?{" "}
          <a className="text-primary" href="/dashboard">
            Continue without linking
          </a>
        </small>
		)}
      </Container>
	  <Testimonials/>
    </div>
  );
};

export default RegisterProfile;
